import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.replace.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.replace.js";
/* eslint-disable */
import { postUploadSave, getUploadGetFileSize } from '@/api';
import utils from '@/utils/utils.js';
import wx from 'wx';
import { base64ToFile } from '@/utils/utils';
// const FormData = require('form-data')

var devices = function (window, document) {
  var noop = function noop(e) {
    return e;
  };
  function download(_ref) {
    var url = _ref.url,
      onSuccess = _ref.onSuccess,
      onFail = _ref.onFail;
    return new Promise(function (reslove, reject) {
      var success = function success(res) {
        onSuccess && onSuccess(res);
        reslove(res);
      };
      var fail = function fail(err) {
        onFail && onFail(err);
        reject(err);
      };
      function translate(str) {
        var value = str.slice(str.lastIndexOf('/') + 1);
        return /\d+-.+/.test(value) ? value.split('-').slice(1).join('-') : value;
      }
      try {
        getUploadGetFileSize({
          fileName: url.slice(url.lastIndexOf('/') + 1)
        }).then(function (res) {
          if (res.success) {
            wx.previewFile({
              url: url,
              name: translate(url),
              size: res.data
            });
            success();
          } else {
            fail();
          }
        }).catch(fail);
      } catch (error) {
        fail(error);
      }
      // wx.invoke(
      //   'openDefaultBrowser',
      //   {
      //     url: url
      //   },
      //   (res) => {
      //     if (res.err_msg != 'openDefaultBrowser:ok') {
      //       fail(res)
      //     } else {
      //       success(res)
      //     }
      //   }
      // )
    });
  }
  function ready(fn) {
    try {
      fn.apply(this, arguments);
    } catch (error) {
      wx.ready(fn);
      console.log('AutoConsole: ready -> error', error);
    }
  }
  var Devices = /*#__PURE__*/function () {
    // Android  Browser iOS   Wx

    function Devices() {
      var _this = this;
      _classCallCheck(this, Devices);
      _defineProperty(this, "property", [{
        name: 'biz.util',
        info: [i18n.tc("95"), i18n.tc("96"), i18n.tc("97"), i18n.tc("98")],
        fn: new Util()
      }, {
        name: 'biz.map',
        info: [i18n.tc("99")],
        fn: new MapLocation()
      }, {
        name: 'device.geolocation.get',
        info: [i18n.tc("100")],
        fn: this.getLocation.bind(this)
      }, {
        name: 'device.base.getUUID',
        info: [i18n.tc("101")],
        fn: function fn(_ref2) {
          var onSuccess = _ref2.onSuccess,
            onFail = _ref2.onFail;
          return _this.UUID ? onSuccess({
            uuid: _this.UUID
          }) : onFail(i18n.tc("102"));
        }
      }, {
        name: 'biz.cspace.saveFile',
        info: [i18n.tc("103")],
        fn: download.bind(this)
      }, {
        name: 'device.notification.actionSheet',
        info: [i18n.tc("104")],
        fn: function fn(_ref3) {
          var onSuccess = _ref3.onSuccess;
          onSuccess({
            buttonIndex: 0
          });
        }
      }, {
        name: 'ui.pullToRefresh.disable',
        info: ['nouse'],
        fn: noop
      }, {
        name: 'ui.webViewBounce.disable',
        info: ['nouse'],
        fn: noop
      }, {
        name: 'biz.telephone.call',
        info: ['nouse'],
        fn: noop
      }, {
        name: 'biz.telephone.showCallMenu',
        info: [i18n.tc("105")],
        fn: function fn(_ref4) {
          var phoneNumber = _ref4.phoneNumber,
            code = _ref4.code;
          var a = document.createElement('a');
          a.href = "tel:".concat(phoneNumber);
          a.click();
        }
      }, {
        name: 'runtime.permission.requestOperateAuthCode',
        info: [i18n.tc("106")],
        fn: function fn(e) {
          return e.onSuccess(e);
        }
      }, {
        name: 'ready',
        info: ['ready'],
        fn: ready
      }, {
        name: 'biz.navigation.setTitle',
        info: [i18n.tc("107")],
        fn: function fn(_ref5) {
          var title = _ref5.title;
          try {
            document.getElementById('AppTitle').innerText = title;
          } catch (error) {}
        }
      }, {
        name: 'hideAllNonBaseMenuItem',
        info: [i18n.tc("108")],
        fn: function fn() {
          try {
            wx.hideAllNonBaseMenuItem();
          } catch (error) {
            console.log('AutoConsole: hideAllNonBaseMenuItem', error);
          }
        }
      }, {
        name: 'onHistoryBack',
        info: [i18n.tc("109")],
        fn: function fn(_fn) {
          try {
            wx.onHistoryBack(_fn);
          } catch (error) {
            console.log('AutoConsole: onHistoryBack');
          }
        }
      }]);
      _defineProperty(this, "version", 'wx1.0');
      _defineProperty(this, "platform", 'Browser');
      _defineProperty(this, "UUID", '');
      _defineProperty(this, "networkState", '');
      _defineProperty(this, "wx", wx);
      var deepSet = function deepSet(str, obj, value) {
        var arr = str.split('.');
        arr.reduce(function (t, v, i) {
          return t[v] = typeof t[v] !== 'undefined' ? t[v] : i === arr.length - 1 ? value : {};
        }, obj);
        return obj;
      };
      this.property.forEach(function (v) {
        deepSet(v.name, _this, v.fn);
      });
      wx.ready && wx.ready(function () {
        return _this.init();
      });
    }
    _createClass(Devices, [{
      key: "isDingtalk",
      value: function isDingtalk() {
        return false;
      }
    }, {
      key: "init",
      value: function init() {
        try {
          console.log('init wx config');
        } catch (error) {
          console.log('init error: ', error);
        }
      }
    }, {
      key: "closeWindow",
      value: function closeWindow() {
        wx.closeWindow();
      }
    }, {
      key: "post",
      value: function post(_ref6) {
        var alias = _ref6.alias,
          content = _ref6.content,
          onSuccess = _ref6.onSuccess,
          onFail = _ref6.onFail,
          attachment = _ref6.attachment,
          text = _ref6.text;
        wx.invoke('createChatWithMsg', {
          selectedOpenUserIds: [],
          selectedTickets: [],
          chatName: i18n.tc("110"),
          msg: {
            msgtype: 'link',
            link: {
              imgUrl: 'http://danxiao2.oss-cn-hangzhou.aliyuncs.com/smy_images/order/20220701/images/1656664295883-1024.png',
              title: attachment.title,
              // 消息标题
              desc: text,
              // 消息描述
              url: attachment.url // 消息链接
            }
          }
        }, function (res) {
          console.log('AutoConsole: post -> res', res);
          if (res.err_msg == 'createChatWithMsg:ok') {
            onSuccess({
              dingCreateResult: true
            });
            // var chatId = res.chatId // 新建的会话ID，当会话为单聊时不返回此字段
          } else {
            onFail();
          }
        });
      }
    }, {
      key: "getLocation",
      value: function getLocation(_ref7) {
        var coordinate = _ref7.coordinate,
          onSuccess = _ref7.onSuccess,
          onFail = _ref7.onFail;
        var _success = /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(back) {
            var longitude, latitude, address;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    longitude = back.longitude, latitude = back.latitude;
                    if (!(coordinate === 1)) {
                      _context.next = 11;
                      break;
                    }
                    address = '';
                    _context.next = 6;
                    return utils.antiAddress([longitude, latitude]);
                  case 6:
                    address = _context.sent;
                    if (!address) {
                      address = "\u5750\u6807\u5730\u5740 \u7ECF\u5EA6:".concat(longitude, i18n.tc("112")).concat(latitude);
                    }
                    onSuccess({
                      longitude: longitude,
                      latitude: latitude,
                      address: address
                    });
                    _context.next = 12;
                    break;
                  case 11:
                    onSuccess({
                      longitude: longitude,
                      latitude: latitude
                    });
                  case 12:
                    _context.next = 17;
                    break;
                  case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](0);
                    onFail(_context.t0);
                  case 17:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 14]]);
          }));
          return function success(_x) {
            return _ref8.apply(this, arguments);
          };
        }();
        wx.getLocation({
          type: 'gcj02',
          // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function success(res) {
            console.log('res: ', res);
            // var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
            // var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
            // var speed = res.speed // 速度，以米/每秒计
            // var accuracy = res.accuracy // 位置精度
            // var gps_status = res.gps_status //gps状态，-1：应用未获取GPS权限；
            // 0：已获取GPS权限，GPS信号异常；
            // 1：已获取GPS权限，GPS信号正常，AGPS信号异常；
            // 2：已获取GPS权限，GPS信号异常，AGPS信号正常；
            // 3：已获取GPS权限，GPS/AGPS信号正常
            if (res.err_Info === 'success' || res.errMsg === 'getLocation:ok') {
              _success(res);
            } else {
              onFail(res);
            }
          },
          fail: function fail(res) {
            console.log('getLocation end', res);
            onFail(res);
          }
        });
      }
    }]);
    return Devices;
  }();
  var WxNavi = function WxNavi() {
    _classCallCheck(this, WxNavi);
  };
  var Util = /*#__PURE__*/function () {
    function Util() {
      _classCallCheck(this, Util);
    }
    _createClass(Util, [{
      key: "scan",
      value: function scan(_ref9) {
        var tips = _ref9.tips,
          onSuccess = _ref9.onSuccess,
          onFail = _ref9.onFail;
        // type为qrCode(二维码)、barCode(条形码)、all(全部)
        return new Promise(function (resolve, reject) {
          wx.scanQRCode({
            desc: i18n.tc("113"),
            needResult: 1,
            // 默认为0，扫描结果由i国网处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'],
            // 可以指定扫二维码还是一维码，默认二者都有
            success: function success(res) {
              onSuccess(res);
              resolve(res);
            },
            error: function error(res) {
              if (res.errMsg.indexOf('function_not_exist') > 0) {
                onFail(i18n.tc("114"));
              } else {
                onFail(err.errMsg);
              }
              reject(err);
            }
          });
        });
      }
    }, {
      key: "openLink",
      value: function openLink(_ref10) {
        var url = _ref10.url,
          _ref10$onSuccess = _ref10.onSuccess,
          onSuccess = _ref10$onSuccess === void 0 ? noop : _ref10$onSuccess,
          _ref10$onFail = _ref10.onFail,
          onFail = _ref10$onFail === void 0 ? noop : _ref10$onFail;
        return download({
          url: url,
          onSuccess: onSuccess,
          onFail: onFail
        });
      }
    }, {
      key: "uploadImageFromCamera",
      value: function uploadImageFromCamera(_ref11) {
        var _this2 = this;
        var upLoadUrl = _ref11.upLoadUrl,
          compression = _ref11.compression,
          max = _ref11.max,
          processCallBack = _ref11.processCallBack,
          onSuccess = _ref11.onSuccess,
          onFail = _ref11.onFail;
        this.camera('camera', {
          compression: compression,
          max: max
        }).then(function (res) {
          if (typeof res === 'string') {
            _this2.upload(res, processCallBack, onSuccess, onFail);
          } else {
            var arr = res.map(function (v) {
              return _this2.upload(v, processCallBack, onSuccess, onFail);
            });
            Promise.all(arr);
          }
        });
      }
    }, {
      key: "uploadImage",
      value: function uploadImage(_ref12) {
        var _this3 = this;
        var upLoadUrl = _ref12.upLoadUrl,
          compression = _ref12.compression,
          max = _ref12.max,
          processCallBack = _ref12.processCallBack,
          onSuccess = _ref12.onSuccess,
          onFail = _ref12.onFail;
        this.camera('all', {
          compression: compression,
          max: max
        }).then(function (res) {
          console.log('uploadImage -> res', res);
          if (typeof res === 'string') {
            _this3.upload(res, processCallBack, onSuccess, onFail);
          } else {
            var arr = res.map(function (v) {
              return _this3.upload(v, processCallBack, onSuccess, onFail);
            });
            Promise.all(arr).catch(function (e) {
              return console.log(e);
            });
          }
        });
      }
    }, {
      key: "camera",
      value: function camera() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'camera';
        var _ref13 = arguments.length > 1 ? arguments[1] : undefined,
          compression = _ref13.compression,
          max = _ref13.max;
        return new Promise(function (reslove, reject) {
          var onSuccess = function onSuccess(imageURI) {
            reslove(imageURI);
          };
          var onFail = function onFail(e) {
            reject(e);
          };
          var source = [];
          if (type === 'camera') {
            source = ['camera'];
          } else {
            source = ['album', 'camera'];
          }
          wx.chooseImage({
            count: max,
            // 默认9
            sizeType: ['original', 'compressed'],
            // 可以指定是原图还是压缩图，默认二者都有
            sourceType: source,
            // 可以指定来源是相册还是相机，默认二者都有
            quality: compression ? 0.5 : 1,
            //压缩质量，范围0～1，数值越小，质量越低，压缩率越高（仅对jpg有效）
            success: function success(res) {
              var localIds = res.localIds; // 返回选定照片的本地ID列表
              onSuccess(localIds);
            },
            fail: function fail(e) {
              onFail(e);
            }
          });
        }).catch(function (e) {
          return console.log(e);
        });
      }
    }, {
      key: "upload",
      value: function upload(localId, processCallBack, onSuccess, onFail) {
        var showName = function showName(item) {
          var value = item.slice(item.lastIndexOf('/') + 1);
          return /\d+-.+/.test(value) ? value.split('-').slice(1).join('-') : value;
        };
        return new Promise(function (reslove, reject) {
          wx.getLocalImgData({
            localId: localId,
            // 图片的localID
            success: function success(res) {
              console.log('AutoConsole: upload -> res', res);
              var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
              if (localData.indexOf('data:image') !== 0) {
                //判断是否有这样的头部
                localData = 'data:image/jpeg;base64,' + localData;
                localData = localData.replace(/\r|\n/g, '');
              }
              var fileName = showName(localId);
              var formData = new FormData();
              formData.append('file', base64ToFile(localData, fileName));
              postUploadSave(formData, {
                maxContentLength: Infinity,
                maxBodyLength: Infinity
                // headers: formData.getHeaders(),
              }).then(function (res) {
                if (res.success) {
                  var file = res.data.fileUrl + res.data.files;
                  onSuccess(file);
                  reslove(file);
                }
              }).catch(function (e) {
                onFail(e);
              });
            }
          });
        });
      }
    }]);
    return Util;
  }();
  var MapLocation = /*#__PURE__*/function () {
    function MapLocation() {
      _classCallCheck(this, MapLocation);
    }
    _createClass(MapLocation, [{
      key: "view",
      value: function view(_ref14) {
        var latitude = _ref14.latitude,
          longitude = _ref14.longitude,
          title = _ref14.title;
        wx.openLocation({
          latitude: latitude,
          // 纬度，浮点数，范围为90 ~ -90
          longitude: longitude,
          // 经度，浮点数，范围为180 ~ -180。
          name: title // 位置名
          // address: '', // 地址详情说明
          // scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为16
        });
      }
    }]);
    return MapLocation;
  }();
  return new Devices();
}(window, document);
export default devices;